import type { ReactNode } from 'react';
import { InfoTip } from '../ui/info-tip';
import type { DrrExplanation } from './drr-explanation';
import { DrrExplanationContent } from './drr-tip';

const drrNumber = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function DrrValue({ value, children, hint }: { value: DrrExplanation; children: ReactNode; hint?: string }) {
  const infinite = (value.drrBasis === 'cabinet' || value.drrBasis === 'product') &&
    value.revenueBuyout === 0 && (value.spend ?? 0) > 0;
  return <span className="rk-drr-value" data-d="дрр-с-основанием">
    <span style={infinite ? { color: 'var(--bad-ink)' } : undefined}>{infinite ? '∞' : typeof value.drr === 'number' && Number.isFinite(value.drr) ? `${drrNumber.format(value.drr)} %` : children}</span>
    <InfoTip label="Как считается ДРР" title="Расчёт ДРР"><DrrExplanationContent value={value} hint={hint}/></InfoTip>
  </span>;
}
